import NewCompany from "layouts/company/newCompany";
import NewInvestmentOpportunity from "layouts/investmentOpportunity/newInvestmentOpportunity";
import Home from "./layouts/home";
import NewQRCode from "layouts/qrcode/NewQRCode";
import NewBadge from "layouts/badge/newBadge";
import BadgeCategory from "layouts/badge/badgeCategory";
import NewBadgeCategory from "layouts/badge/badgeCategory/newBadgeCategory";
import NewMission from "layouts/mission/newMission";
import MissionCategory from "layouts/mission/missionCategory";
import NewMissionCategory from "layouts/mission/missionCategory/newMissionCategory";
import UserMissions from "layouts/mission/userMissions";

const partialRoutes = [
    {
        path: "/",
        element: <Home />
    },
    {
        path: "/new-investment-opportunity",
        element: <NewInvestmentOpportunity />
    },
    {
        path: "/new-company",
        element: <NewCompany />
    },
    {
        path: "/new-mission",
        element: <NewMission />
    },
    {
        path: "/new-badge",
        element: <NewBadge />
    },
    {
        path: "/badge-category",
        element: <BadgeCategory />
    },
    {
        path: "/mission-category",
        element: <MissionCategory />
    },
    {
        path: "/user-missions",
        element: <UserMissions />
    },
    {
        path: "/new-mission-category",
        element: <NewMissionCategory />
    },
    {
        path: "/new-badge-category",
        element: <NewBadgeCategory />
    },
    {
        path: "/new-qr-code",
        element: <NewQRCode />
    },
];

export default partialRoutes;
